import React from 'react';
import PageHeaderSection from 'app/components/misc/PageHeaderSection';
import { RichText } from 'prismic-reactjs';
import * as S from './styles';

const PrivacyContent = ({ doc }) => {
  const conditions = doc.privacy.map((condition, index) => {
    return <S.Text key={index}>{RichText.render(condition.term)}</S.Text>;
  });

  return (
    <>
      <PageHeaderSection
        title="Privacy Statement"
        subtitle={RichText.asText(doc.version)}
      />
      <S.PageContent>{conditions}</S.PageContent>
    </>
  );
};

export default PrivacyContent;
